import React, { FC, useEffect, useState } from "react";
import CustomDraggableDialog from "../common/customDialog/CustomDraggableDialog";
import TranslatedMessage from "../translations/TranslatedMessage";
import ExamSelect from "../examSession/ExamSelect";
import { ExamTemplateWithStructureIndex } from "../../model/Exam";

interface SchedulerExamSelectDialogProps {
  opened: boolean;
  isMulti: boolean;
  exams: ExamTemplateWithStructureIndex[];
  accept: (examIds: string[]) => void;
  decline: () => void;
}

const SchedulerExamSelectDialog: FC<SchedulerExamSelectDialogProps> = ({ opened, isMulti, exams, accept, decline }) => {
  const [selectedExamIds, setSelectedExamIds] = useState<string[]>([]);

  useEffect(() => {
    if (opened) {
      setSelectedExamIds([]);
    }
  }, [opened]);

  const handleAddExam = (examId: string) => {
    setSelectedExamIds((prevSelectedExamIds) => (isMulti ? [...prevSelectedExamIds, examId] : [examId]));
  };

  const handleRemoveExam = (examId: string) => {
    setSelectedExamIds((prevSelectedExamIds) => prevSelectedExamIds.filter((id) => id !== examId));
  };

  const handleClearExams = () => {
    setSelectedExamIds([]);
  };

  const applySelectedExam = () => {
    if (selectedExamIds.length > 0) {
      accept(selectedExamIds);
    }
  };

  return (
    <CustomDraggableDialog
      acceptText={<TranslatedMessage id="common.accept" />}
      cancelText={<TranslatedMessage id="common.cancel" />}
      content={
        <ExamSelect
          exams={exams}
          selectedExamIds={selectedExamIds}
          isMulti={isMulti}
          add={handleAddExam}
          remove={handleRemoveExam}
          clear={handleClearExams}
        />
      }
      isOpen={opened}
      onAccept={applySelectedExam}
      onCancel={decline}
      title={<TranslatedMessage id="scheduler.examSelectDialog.title" />}
    />
  );
};

export default SchedulerExamSelectDialog;
